import { render, staticRenderFns } from "./PriceBlock.vue?vue&type=template&id=29a9bb38&scoped=true&"
import script from "./PriceBlock.vue?vue&type=script&lang=js&"
export * from "./PriceBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a9bb38",
  null
  
)

export default component.exports